var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _vm.currentUserSupportContextCount ? _c('div', {
    staticClass: "active_user_support_display",
    class: _vm.hasOnlyOneContext ? 'one_ctx' : '',
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('v-slide-y-transition', {
    attrs: {
      "hide-on-leave": ""
    }
  }, [_vm.hasOnlyOneContext && _vm.currentUserSupportContext ? _c('div', {
    staticClass: "c-flex no-gap align-items-center",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('c-icon-fa', {
    staticClass: "pr-2",
    attrs: {
      "icon": _vm.$icons[_vm.EntityType.ORGANIZATION],
      "icon-color": "white",
      "icon-size": "22px"
    }
  }), _c('span', {
    staticStyle: {
      "font-weight": "400",
      "font-size": "18px",
      "-webkit-font-smoothing": "auto"
    }
  }, [_vm._v(_vm._s(_vm.CosmicUserSupportContextDisplay.get(_vm.currentUserSupportContext)))])], 1) : !_vm.isReloading && _vm.showUserSupportContextList && _vm.currentUserSupportContext ? _c('c-menu', {
    attrs: {
      "align-right": "",
      "border-color": "var(--cosmic-text)",
      "border-size": "1px",
      "nudge-top": "0px"
    }
  }, [_c('ButtonMiniActionNavbar', {
    staticClass: "context_button pr-2",
    attrs: {
      "slot": "activator",
      "disable-scale-on-hover": "",
      "tooltip": "Open Context menu",
      "tooltip-position": "bottom",
      "width-auto": ""
    },
    slot: "activator"
  }, [_c('c-icon-fa', {
    attrs: {
      "icon": _vm.$icons[_vm.EntityType.ORGANIZATION],
      "icon-color": "currentColor",
      "icon-size": "22px"
    }
  }), _c('span', {
    staticStyle: {
      "font-weight": "400",
      "font-size": "18px",
      "-webkit-font-smoothing": "auto"
    }
  }, [_vm._v(" " + _vm._s(_vm.CosmicUserSupportContextDisplay.get(_vm.currentUserSupportContext)) + " ")])], 1), _vm._l(_vm.selectOptions, function (support, index) {
    return _c('c-menu-item', {
      key: index,
      style: {
        backgroundColor: support.organizationCode === _vm.currentUserSupportContext ? 'var(--v-organizations-base)' : 'white'
      },
      attrs: {
        "icon-color": support.organizationCode === _vm.currentUserSupportContext ? 'white' : 'var(--cosmic-text)',
        "icon": _vm.$icons[_vm.EntityType.ORGANIZATION],
        "icon-size": "18px"
      },
      on: {
        "c-click": function ($event) {
          return _vm.handleUserSupportSelection(support);
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-weight": "400",
        "font-size": "14px",
        "-webkit-font-smoothing": "auto"
      },
      style: {
        color: support.organizationCode === _vm.currentUserSupportContext ? 'white' : 'var(--cosmic-text)'
      }
    }, [_vm._v(" " + _vm._s(_vm.userSupportDisplay(support.organizationCode)) + " ")])]);
  })], 2) : _vm.isReloading ? _c('div', {
    staticStyle: {
      "background": "#323a45",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "height": "100%"
    }
  }, [_c('c-spinner', {
    attrs: {
      "color": "white"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };